import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Title from "../general/title"
import ReactTable from "react-table"
import _ from "lodash"
import times from "helpers/times"
import moment from "moment"
import Switch from "react-switch"
import currentUser from "helpers/currentUser"
import settings from "settings"

class WeeklySummary extends Component {
	constructor(props) {
		super(props)

		this.state = {
			current: true, // viewing current week instead of last
			columns: [
				{
					Header: "Builder",
					accessor: "builder",
				},
				{
					Header: "Salesperson",
					accessor: "salesperson",
				},
				{
					Header: "Last Activity",
					accessor: "lastActivity",
				},
				{
					Header: "Sales",
					accessor: "sales",
				},
				{
					Header: "Cancellations",
					accessor: "cancels",
				},
				{
					Header: "Transfers",
					accessor: "transfers",
				},
				{
					Header: "Starts",
					accessor: "starts",
				},
				{
					Header: "Closings",
					accessor: "closings",
				},
				{
					Header: "Traffic",
					accessor: "traffic",
				},
				{
					Header: "Grouped Traffic",
					accessor: "grouped_traffic",
				},
				{
					Header: "CoPilot Text",
					accessor: "copilotText",
				},
			],
			selectedWeek: times().curWeek,
			startText: moment.unix(times().thisWeek).format("MMMM D"),
			endText: moment.unix(times().thisWeek).add(6, "days").format("MMMM D"),
			times: times(),
			user: currentUser(),
		}
	}

	buildTable = (type) => {
		let ret = []
		let salespeople = {}
		let model = {
			sales: 0,
			cancels: 0,
			transfers: 0,
			closings: 0,
			traffic: 0,
			starts: 0,
			grouped_traffic: 0,
			copilotText: 0,
			noActivity: false,
			lastActivity: 0,
			hasGrouped: false,
		}
		if (
			this.state.user?.group === 2 &&
			(!this.props.payload.salesManagerPayload.overSalespeople ||
				this.props.payload.salesManagerPayload.overSalespeople?.length === 0)
		) {
			return []
		}
		_.forEach(this.props.payload.public.salespeople, (r) => {
			if (r.status !== 1 || r.builder_portal !== 1) {
				return
			}
			if (this.state.user.group == 2) {
				if (!this.props.payload.salesManagerPayload?.overSalespeople?.includes(r.id)) {
					return
				}
			}
			if (_.intersection(this.props.activeProperties, r.properties).length > 0) {
				if (!_.has(salespeople, r.id)) {
					r.model = _.clone(model)
					salespeople[r.id] = r
				}
			}
		})
		let set
		if (this.state.user.group == 2) {
			set = this.state.current
				? this.props.payload.salesManagerPayload.weeklyActivity.this
				: this.props.payload.salesManagerPayload.weeklyActivity.last
		} else {
			set = this.state.current
				? this.props.payload.exec.weeklyActivity.this
				: this.props.payload.exec.weeklyActivity.last
		}
		// Add on their sales/cans/starts etc
		_.forEach(set, (type, typeName) => {
			_.forEach(type, (v) => {
				try {
					if (v.viewAs) v.user = v.viewAs // user is the person who actually took the action.  if an admin is viewing as someone and puts traffic in, then they want to see the "viewAs" which is the salesperson.  v.user is the admin's id.
					if (!salespeople[v.user] || !this.props.activeProperties.includes(v.property)) {
						return
					}
					if (typeName == "grouped_traffic") {
						let numbers = v.excerpt?.match(/\d+/g)?.map(Number)
						if (numbers) {
							salespeople[v.user].model[typeName] += _.sum(numbers)
						}
						salespeople[v.user].model.hasGrouped = true
					} else {
						salespeople[v.user].model[typeName]++
					}

					if (v.addedDate > salespeople[v.user].model.lastActivity) {
						salespeople[v.user].model.lastActivity = v.addedDate
					}
				} catch (e) {
					console.log(e)
				}
			})
		})
		//console.log(salespeople)
		_.forEach(salespeople, (r) => {
			let builder = _.find(this.props.payload.public.builders, { id: r.builders[0] })
			if (!builder) {
				return
			}
			let last = ""
			if (this.state.current) {
				if (r.model.lastActivity && r.model.lastActivity >= times().thisWeek) {
					last = moment.unix(r.model.lastActivity).format("MM/DD/YY LT")
				}
			} else {
				if (
					r.model.lastActivity &&
					r.model.lastActivity >= times().lastWeek &&
					r.model.lastActivity < times().thisWeek
				) {
					last = moment.unix(r.model.lastActivity).format("MM/DD/YY LT")
				}
			}
			if (r.model.lastActivity && r.model.lastActivity >= times().thisWeek) {
				last = moment.unix(r.model.lastActivity).format("MM/DD/YY LT")
			}
			// No Activity for this person
			if (r.model.noActivity) {
				ret.push({
					builder: builder.name,
					salesperson: `${r.first} ${r.last}`,
					sales: 0,
					cancels: 0,
					transfers: 0,
					starts: 0,
					closings: 0,
					traffic: 0,
					copilotText: 0,
					lastActivity: last,
				})
			} else {
				// If they enter 0 for grouped traffic:
				if (r.model.grouped_traffic == 0 && r.model.hasGrouped) {
					r.model.grouped_traffic = "0"
				}
				ret.push({
					builder: builder.name,
					salesperson: `${r.first} ${r.last}`,
					sales: r.model.sales ? r.model.sales : "",
					cancels: r.model.cancels ? r.model.cancels : "",
					transfers: r.model.transfers ? r.model.transfers : "",
					starts: r.model.starts ? r.model.starts : "",
					closings: r.model.closings ? r.model.closings : "",
					traffic: r.model.traffic ? r.model.traffic : "",
					grouped_traffic: r.model.grouped_traffic ? r.model.grouped_traffic : "",
					copilotText: r.model.copilotText ? r.model.copilotText : "",
					lastActivity: last,
				})
			}
		})
		return ret
	}

	getTrProps = (state, rowInfo, instance) => {
		if (rowInfo) {
			let v = rowInfo.original
			if (
				v.sales === 0 &&
				v.cancels === 0 &&
				v.transfers === 0 &&
				v.closings === 0 &&
				v.starts === 0 &&
				v.traffic === 0 &&
				v.copilotText === 0
			) {
				// This is "no activity"
				return { className: "statusColor--approved" }
			} else if (
				!v.sales &&
				!v.cancels &&
				!v.transfers &&
				!v.closings &&
				!v.starts &&
				!v.traffic &&
				!v.grouped_traffic &&
				!v.copilotText
			) {
				return { className: "statusColor--rejected" }
			} else {
				return { className: "statusColor--approved" }
			}
		}
		return {}
	}

	toggle = () => {
		let startText, endText, selectedWeek
		if (this.state.current) {
			selectedWeek = this.state.times.lastWeekNumber
			startText = moment.unix(times().thisWeek).subtract(1, "week").format("MMMM D")
			endText = moment.unix(times().thisWeek).subtract(1, "week").add(6, "days").format("MMMM D")
		} else {
			selectedWeek = this.state.times.curWeek
			startText = moment.unix(times().thisWeek).format("MMMM D")
			endText = moment.unix(times().thisWeek).add(6, "days").format("MMMM D")
		}
		this.setState({ current: !this.state.current, startText, endText, selectedWeek })
	}

	render() {
		if (this.props.payloadStatus) {
			return (
				<div className="admin">
					<div className="imageGroup">
						<Title title="Weekly Summary" showDate={false} />
						<div className="content">
							<div className="twoCol">
								<p className="mid">
									Week {this.state.selectedWeek} | Monday {this.state.startText + " "}- Sunday{" "}
									{this.state.endText}
								</p>
								<div className="switchBox__switch">
									<p>Viewing {(this.state.current && "This Week") || "Last Week"}</p>
									<Switch
										onChange={this.toggle}
										checked={this.state.current}
										checkedIcon={false}
										uncheckedIcon={false}
									/>
								</div>
							</div>
							<ReactTable
								data={this.buildTable()}
								loadingText=""
								columns={this.state.columns}
								defaultPageSize={20}
								getTrProps={this.getTrProps}
								defaultSorted={[
									{
										id: "salesperson",
										asc: true,
									},
								]}
							/>
						</div>
					</div>
				</div>
			)
		} else {
			return ""
		}
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(WeeklySummary)
